<template>
  <div class="bottom-nav-container">
    
    <div class="bottom-nav-item" :class="{ 'active': isActive('TeacherMyProfile') }" @click="navigateTo('TeacherMyProfile')">
      <div class="nav-circle-wrapper">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="2" width="20" height="20" rx="5" :stroke="isActive('TeacherMyProfile') ? '#FFFFFF' : '#8C9EFF'" stroke-width="2.5"/>
          <circle cx="12" cy="12" r="4" :stroke="isActive('TeacherMyProfile') ? '#FFFFFF' : '#8C9EFF'" stroke-width="2.5"/>
          <circle cx="18" cy="6" r="1.5" :fill="isActive('TeacherMyProfile') ? '#FFFFFF' : '#8C9EFF'"/>
        </svg>
      </div>
    </div>

    <div class="bottom-nav-item" :class="{ 'active': isActive('TeacherAddPost') }" @click="navigateTo('TeacherAddPost')">
      <div class="nav-circle-wrapper">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 5V19" :stroke="isActive('TeacherAddPost') ? '#FFFFFF' : '#8C9EFF'" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5 12H19" :stroke="isActive('TeacherAddPost') ? '#FFFFFF' : '#8C9EFF'" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

    <div class="bottom-nav-item" :class="{ 'active': isActive('TeacherHome') }" @click="navigateTo('TeacherHome')">
      <div class="nav-circle-wrapper">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" :fill="isActive('TeacherHome') ? '#FFFFFF' : '#8C9EFF'"/>
        </svg>
      </div>
    </div>

    <div class="bottom-nav-item" :class="{ 'active': isActive('TeacherMyChats') }" @click="navigateTo('TeacherMyChats')">
      <div class="nav-circle-wrapper">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 2L11 13" :stroke="isActive('TeacherMyChats') ? '#FFFFFF' : '#8C9EFF'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M22 2L15 22L11 13L2 9L22 2Z" :fill="isActive('TeacherMyChats') ? '#FFFFFF' : '#8C9EFF'"/>
        </svg>
        <div v-if="hasUnseenChat" class="notification-dot"></div>
      </div>
    </div>

    <div class="bottom-nav-item" :class="{ 'active': isActive('TeacherUserArea') }" @click="navigateTo('TeacherUserArea')">
      <div class="nav-circle-wrapper">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" :fill="isActive('TeacherUserArea') ? '#FFFFFF' : '#8C9EFF'"/>
          <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26003 15 3.40997 18.13 3.40997 22" stroke-width="0" :fill="isActive('TeacherUserArea') ? '#FFFFFF' : '#8C9EFF'"/>
          <path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22" stroke="none" :fill="isActive('TeacherUserArea') ? '#FFFFFF' : '#8C9EFF'"/>
        </svg>
      </div>
    </div>

  </div>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'TeacherBottomNav',
  data() {
    return {
      hasUnseenChat: false,
      intervalId: null
    }
  },
  mounted() {
    this.checkLocalStatus();
    this.checkServerStatus();
    this.intervalId = setInterval(this.checkServerStatus, 5000);
  },
  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    navigateTo(routeName) {
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName })
      }
    },
    isActive(routeName) {
      return this.$route.name === routeName
    },
    checkLocalStatus() {
      const unseen = localStorage.getItem('teacher_has_unseen_chat');
      this.hasUnseenChat = unseen === '1';
    },
    async checkServerStatus() {
      try {
        const userId = localStorage.getItem('user_id');
        if (!userId) return;

        const formData = createFormData({
          teacher_id: userId,
          user_id: userId
        });

        const response = await apiClient.post('/teacher/home_page', formData);

        if (response.data.status === 'ok' && response.data.data) {
          const alarmNewChat = response.data.data.alarm_new_chat || 0;
          
          if (alarmNewChat > 0) {
            this.hasUnseenChat = true;
            localStorage.setItem('teacher_has_unseen_chat', '1');
          } else {
            this.hasUnseenChat = false;
            localStorage.setItem('teacher_has_unseen_chat', '0');
          }
        }
      } catch (error) {
        console.error("Error checking notification status", error);
      }
    }
  }
}
</script>

<style scoped>
.bottom-nav-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  padding: 0 10px;
}

.bottom-nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 1;
  height: 100%;
  position: relative;
  -webkit-tap-highlight-color: transparent;
}

.nav-circle-wrapper {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;
  position: relative;
  background-color: transparent;
}

.bottom-nav-item.active .nav-circle-wrapper {
  background-color: #5B67F1;
}

.notification-dot {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 9px;
  height: 9px;
  background-color: #FF3B30;
  border-radius: 50%;
  border: 1.5px solid white;
  z-index: 10;
}

.bottom-nav-item:active .nav-circle-wrapper svg {
  transform: scale(0.95);
  transition: transform 0.1s;
}
</style>